export class AudioEngineError extends Error {
  constructor(
    message: string,
    public readonly code:
      'NO_TRACKS' | 'DECODE_FAILED' | 'INVALID_DURATION' | 'MISSING_TRACK' | 'CONTEXT_FAILED',
    options?: ErrorOptions,
  ) {
    super(message, options);
    this.name = 'AudioEngineError';
  }
}
